const customerPath = (subdomain, admin = true) => {
  const path = global.location.hostname.split('.');

  path.shift();

  if (path.length === 0) {
    return null;
  }

  path.unshift(subdomain);

  const url = `${global.location.protocol}//${path.join('.')}${global.location.port ? `:${global.location.port}` : ''}`;

  return admin ? `${url}/admin` : url;
};

export default customerPath;
